import React from 'react';
import PropTypes from 'prop-types';

function NotAvailable(props) {
  const { type = 'Resource', children, imgSrc, ..._props } = props;

  return (
    <div className="nodataFoundDetail" {..._props}>
      <div className="nodataFoundInner">
        {imgSrc && <img src={imgSrc} />}
        {children ?? <span>{type} not Available</span>}
      </div>
    </div>
  );
}

NotAvailable.propTypes = {
  type: PropTypes.string,
  children: PropTypes.any,
  imgSrc: PropTypes.node,
};

export default React.memo(NotAvailable);
